import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export function usePageNumberRouting() {
  const history = useHistory();
  const location = useLocation();

  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const updateUrl = useCallback(
    (page: number, { replace }: { replace?: boolean } = {}) => {
      query.set("page", `${page}`);
      replace
        ? history.replace({
            pathname: location.pathname,
            search: query.toString(),
          })
        : history.push({
            pathname: location.pathname,
            search: query.toString(),
          });
    },
    [history, location.pathname, query]
  );

  const page = useMemo(() => {
    const queryAsInt = Number(`${query.get("page")}`);
    if (isNaN(queryAsInt) || queryAsInt < 1) {
      return 1;
    }
    return queryAsInt;
  }, [query]);

  return { page, setPage: updateUrl };
}
